import React, { useRef, useState } from "react";
import "../assets/styles/Contact.scss";
import emailjs from "@emailjs/browser";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import TextField from "@mui/material/TextField";

function Contact() {
	const [name, setName] = useState<string>("");
	const [email, setEmail] = useState<string>("");
	const [message, setMessage] = useState<string>("");

	const [nameError, setNameError] = useState<boolean>(false);
	const [emailError, setEmailError] = useState<boolean>(false);
	const [emailErrorMessage, setEmailErrorMessage] = useState<string>("");
	const [messageError, setMessageError] = useState<boolean>(false);

	const form = useRef();

	const validateEmail = (email: string): boolean => {
		// Email regex pattern
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!emailRegex.test(email)) {
			setEmailErrorMessage("Please enter a valid email address");
			return false;
		}

		return true;
	};

	const sendEmail = (e: any) => {
		e.preventDefault();

		// Validate all fields
		const isNameValid = name.trim() !== "";
		const isMessageValid = message.trim() !== "";

		// Email validation with proper error message
		let isEmailValid = false;
		if (email.trim() === "") {
			setEmailErrorMessage("Please enter your email");
			isEmailValid = false;
		} else {
			isEmailValid = validateEmail(email);
		}

		setNameError(!isNameValid);
		setEmailError(!isEmailValid);
		setMessageError(!isMessageValid);

		if (isNameValid && isEmailValid && isMessageValid) {
			const templateParams = {
				name: name,
				email: email,
				message: message,
			};

			console.log(templateParams);
			emailjs
				.send(
					process.env.REACT_APP_EMAILJS_SERVICE_ID!,
					process.env.REACT_APP_EMAILJS_TEMPLATE_ID!,
					templateParams,
					process.env.REACT_APP_EMAILJS_PUBLIC_KEY!
				)
				.then(
					(response) => {
						console.log("SUCCESS!", response.status, response.text);
					},
					(error) => {
						console.log("FAILED...", error);
					}
				);
			setName("");
			setEmail("");
			setMessage("");
			setEmailErrorMessage("");
		}
	};

	return (
		<div id="contact">
			<div className="items-container">
				<div className="contact_wrapper">
					<h1>Contact Me</h1>
					<p>
						Got a project waiting to be realized? Let's collaborate and make it
						happen!
					</p>
					<Box
						ref={form}
						component="form"
						noValidate
						autoComplete="off"
						className="contact-form"
					>
						<div className="form-flex">
							<TextField
								required
								id="outlined-required"
								label="Your Name"
								placeholder="What's your name?"
								value={name}
								onChange={(e) => {
									setName(e.target.value);
								}}
								error={nameError}
								helperText={nameError ? "Please enter your name" : ""}
							/>
							<TextField
								required
								id="outlined-email"
								label="Email"
								placeholder="your.email@example.com"
								type="email"
								value={email}
								onChange={(e) => {
									setEmail(e.target.value);
								}}
								error={emailError}
								helperText={emailError ? emailErrorMessage : ""}
							/>
						</div>
						<TextField
							required
							id="outlined-multiline-static"
							label="Message"
							placeholder="Send me any inquiries or questions"
							multiline
							rows={10}
							className="body-form"
							value={message}
							onChange={(e) => {
								setMessage(e.target.value);
							}}
							error={messageError}
							helperText={messageError ? "Please enter the message" : ""}
						/>
						<Button
							variant="contained"
							endIcon={<SendIcon />}
							onClick={sendEmail}
						>
							Send
						</Button>
					</Box>
				</div>
			</div>
		</div>
	);
}

export default Contact;
